// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"94":"7abc983d","189":"83c93bc6"}[chunkId] + ".js";
};